import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { Box } from "@mui/system";

export const filteringOptions = [
  { value: 0, label: "الكل" },
  { value: 2, label: "أحدث مقاطع الفيديو" },
  { value: 1, label: "الأكثر مشاهدة" },
];

export default function FilteringChips({ active, setActive, loading }) {
  const handleClick = (e) => {
    setActive(+e.target.id);
  };

  return (
    <Box mt={1} width="100%">
      <Stack
        flexDirection="row"
        justifyContent="flex-start"
        gap={{ xs: 0.4, sm: 1.5 }}
        boxShadow={0}
        overflow="scroll"
        py={3}
        px={1}
      >
        {filteringOptions.map((data) => {
          const isActive = active === data.value;
          return (
            <LoadingButton
              loading={loading && isActive}
              size="small"
              key={data.value}
              id={data.value + ""}
              variant="contained"
              color={isActive && !loading ? "primary" : "lightgrey"}
              loadingPosition="start"
              sx={{
                borderRadius: "3rem",
                px: 2,
                paddingInlineStart: loading && isActive ? 5 : 2,
                py: 0.3,
                textAlign: "center",
                color: (theme) =>
                  isActive && !loading
                    ? theme.palette.primary.contrastColor
                    : theme.palette.lightgrey.contrastColor,
                whiteSpace: "nowrap",
                minWidth: "min-content",
                minHeight: "min-content",
                ":hover": {
                  boxShadow: "none",
                  backgroundColor: (theme) =>
                    isActive && !loading
                      ? theme.palette.primary.dark
                      : theme.palette.lightgrey.dark,
                },
              }}
              onClick={handleClick}
            >
              {data.label}
            </LoadingButton>
          );
        })}
      </Stack>
    </Box>
  );
}
